const CHANNEL_NAME = "phoneboard:policy-upload-refresh";

type UploadRefreshMessage = { uploadId: number };

/**
 * 업로드 재처리가 끝났음을 다른 브라우저 창에 알린다.
 *
 * 현재 창의 React Query 캐시는 호출부가 직접 무효화한다. 이 통로는 별도 팝아웃처럼
 * QueryClient를 공유하지 않는 창만 위한 것으로, 서버 요청을 주기적으로 늘리지 않는다.
 */
export function publishPolicyUploadRefresh(uploadId: number): void {
  if (typeof BroadcastChannel === "undefined") return;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage({ uploadId } satisfies UploadRefreshMessage);
  // postMessage로 큐에 넣은 뒤 닫는다. 약간의 여유를 둬 브라우저별 전달 차이를 흡수한다.
  window.setTimeout(() => channel.close(), 1_000);
}

/** 지정한 업로드의 완료 신호만 받는다. */
export function subscribePolicyUploadRefresh(uploadId: number, refresh: () => void): () => void {
  if (typeof BroadcastChannel === "undefined") return () => undefined;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (event: MessageEvent<UploadRefreshMessage>) => {
    if (event.data?.uploadId === uploadId) refresh();
  };
  return () => channel.close();
}
